import moment from 'moment';

const styles = {
  textAlign: 'center'
};

export const requestsColumns = ({ t }) => {
  return [
    {
      Header: t('attachChildColumn_request'),
      style: styles,
      width: 200,
      Cell: row => {
        return row.original?.id ?? '';
      }
    },
    {
      Header: t('attachChildColumn_childIin'),
      style: styles,
      Cell: row => {
        return row.original?.childIin ?? '';
      }
    },
    {
      Header: t('attachChildColumn_date'),
      style: styles,
      Cell: row => {
        return moment(row.original?.createdAt).format('DD.MM.YYYY HH:mm');
      }
    },
    {
      Header: t('attachChildColumn_status'),
      style: styles,
      Cell: row => {
        return t(`attachChildColumn_status_${row.original?.status}`) ?? '';
      }
    },
    {
      Header: t('attachChildColumn_reason'),
      Cell: row => {
        return row.original?.declineReason ?? '';
      }
    }
  ];
};
